/**
 * This type should be returned by the handleSave() method of the parent component of
 * an <AsidePanel>.
 *
 * By returning an instance of this type, the parent component can consistently indicate to the
 * <AsidePanel> the following conditions:
 *
 * - When canContinue is false the <AsidePanel> will not close itself and redirect back to the `
 *   <MainPanel>. Instead the <AsidePanel> will remain open. This can be used to abort the save
 *   with out raising an error.
 * - TODO: When noNotification is true then the <AsidePanel> will not display a toast notification
 *   informing the admin that the item was saved successfully.
 * - TODO: When noRedirect is true then the <AsidePanel> will _not_ redirect to the main panel.
 */
export default function SaveReturnValue(params = {}) {
  const {
    canContinue = true,
    message = null,
    noNotification = false,
    noRedirect = false,
  } = params;

  this.canContinue = canContinue;
  this.message = message;
  this.noNotification = noNotification;
  this.noRedirect = noRedirect;
}
